import { ProductCardPropsTypes } from '../interfaces';

import { ProductCard as ProductCardProps } from './ProductCard';
import { ProductImage } from './ProductImage';
import { ProductTitle } from './ProductTitle';
import { ProductButtons } from './ProductButtons';

export { ProductImage } from './ProductImage';
export { ProductTitle } from './ProductTitle';
export { ProductButtons } from './ProductButtons';

export const ProductCard: ProductCardPropsTypes = Object.assign(ProductCardProps,
  {
    Title: ProductTitle,
    Image: ProductImage,
    Buttons: ProductButtons
  }
);

export default ProductCard;